import React from 'react'
import { GLOBAL_STATIC_FILES } from '../utils'
import "../components/Header/header.css";
import step1 from "../assets/images/step1.jpg"
import step2 from "../assets/images/step2.jpeg"
import step3 from "../assets/images/step3.jpeg"
import step4 from "../assets/images/step4.jpeg"
import step5 from "../assets/images/step5.jpeg"
import { Row, Col } from 'antd';
const DeleteSteps = () => {
    return (
        <div>
            <div className="fixed-header">
                <div className="header-div">
                    <Row style={{
                        alignItems: "center"
                    }}>
                        <Col span={9} className="logoContainer">
                            <img
                                src={GLOBAL_STATIC_FILES.COMPANY_LOGO}
                                alt={"logo"}
                                className="header-logo ml2"
                            />
                        </Col >
                    </Row>
                </div>
            </div>
            <div className='mt7'>
                <div className="policy_section refund_policy">
                    <h3 className="policy_header" style={{color: '#000'}}>Delete User Account</h3>
                    <p className="query_section">
                        <ol>
                            <li>
                                Login to the application and goto menu then click Personal Details.
                                <div style={{ width: "21rem" }} className='m1'>
                                    <img src={step1} alt="first step image" className='w100' />
                                </div>
                            </li>
                            <li className='mt3'>
                                Bottom of the page we will be having the Delete Account Option.
                                <div style={{ width: "21rem" }} className='m1'>
                                    <img src={step2} alt="first step image" className='w100' />
                                </div>
                            </li>
                            <li className='mt3'>
                                Click on Delete Account and will be getting a popup for the confirmation of the deletion.
                                <div style={{ width: "21rem" }} className='m1'>
                                    <img src={step3} alt="first step image" className='w100' />
                                </div>
                            </li>
                            <li className='mt3'>
                                When we click on Yes in the pop up then the account will be deleted.
                                <div style={{ width: "21rem" }} className='m1'>
                                    <img src={step4} alt="first step image" className='w100' />
                                </div>
                            </li>
                            <li className='mt3'>
                                Finally moving on to the Login page and when we try to login with deleted account credentials it will show the error message stating the account is deleted.
                                <div style={{ width: "21rem" }} className='m1'>
                                    <img src={step5} alt="first step image" className='w100' />
                                </div>
                            </li>
                        </ol>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default DeleteSteps;